import React from "react";
import { Button, theme } from "antd";
import { useBailiffUpload } from "hook/bailiff/document/action/useBailiffUpload";
import { HiPlus } from "react-icons/hi";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const UploadBtn = () => {
  // -------------------------- VAR -----------------------------
  const { handleOpen } = useBailiffUpload();
  const primary = theme.useToken().token.blue;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Button
      onClick={handleOpen}
      style={{
        width: 170,
        height: 130,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <HiPlus size={40} color={primary} />
      <div style={{ color: "#aeaeae" }}>Thêm file</div>
    </Button>
  );
};
export default UploadBtn;
